var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3532_10362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 60.5C23.0591 60.5 16.3331 58.0935 10.9679 53.6904C5.60268 49.2874 1.93013 43.1602 0.576037 36.3529C-0.778061 29.5456 0.270069 22.4794 3.54184 16.3583C6.81361 10.2371 12.1066 5.4398 18.5189 2.78369C24.9312 0.127575 32.0661 -0.222981 38.7079 1.79175C45.3498 3.80648 51.0875 8.06184 54.9436 13.8328C58.7996 19.6037 60.5354 26.5331 59.8551 33.4404C59.1748 40.3476 56.1206 46.8053 51.2129 51.7131C48.4335 54.5075 45.1276 56.7229 41.4864 58.2312C37.8452 59.7394 33.941 60.5106 29.9998 60.5ZM29.9998 5.89302C16.4318 5.89302 5.39494 16.9321 5.39494 30.5C5.39494 44.068 16.434 55.1059 30.0019 55.1059C43.5699 55.1059 54.6067 44.068 54.6067 30.5C54.6067 16.9321 43.5677 5.89302 29.9998 5.89302Z",
    fill: "#41AF60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5964 43.6719C27.2423 43.672 26.8917 43.6022 26.5646 43.4666C26.2375 43.3309 25.9404 43.1322 25.6902 42.8816L15.4502 32.6437C14.9489 32.1371 14.6685 31.4527 14.6704 30.74C14.6723 30.0273 14.9562 29.3443 15.4602 28.8403C15.9642 28.3364 16.6471 28.0524 17.3598 28.0505C18.0725 28.0487 18.757 28.329 19.2636 28.8303L27.4202 36.988L52.8716 6.49062C53.3304 5.94149 53.9885 5.59711 54.7012 5.53324C55.4139 5.46937 56.1228 5.69124 56.672 6.15004C57.2211 6.60884 57.5655 7.26699 57.6293 7.97971C57.6932 8.69242 57.4713 9.40132 57.0125 9.95045L29.6669 42.7108C29.4273 42.998 29.1305 43.2322 28.7955 43.3984C28.4604 43.5647 28.0944 43.6593 27.7207 43.6763C27.6775 43.6719 27.6364 43.6719 27.5964 43.6719Z",
    fill: "#41AF60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3532_10362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccessful);
export default __webpack_public_path__ + "static/media/paymentSuccessful.0fcf0e3021453ae700fb8a03af25fd81.svg";
export { ForwardRef as ReactComponent };